var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import * as React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { PORTAL_ROUTE_PREFIX } from '../../constants/values';
import { ROUTES } from '../../constants/routes';
import OptIn from '../../components/OptIn/OptIn';
import ContactSales from '../../components/ContactSales/ContactSales';
import SharedCalendar from '../../components/GroupOrdersSharedCalendar/SharedCalendar';
import PreviewVoucher from '../../components/Vouchers/Participants/PreviewVoucher';
import AcceptVoucher from '../../components/Vouchers/Participants/AcceptVoucher';
import JoinByInviteRoutes from '../../components/JoinByInvite/JoinByInviteRoutes';
import LocationPathHelper from '../../utils/location_path_helper';
import { QUERY_PARAMS } from '../../constants/queryParams';
import { appendParamToSearchParam } from '../../utils/urlHelper';
import PreviewVoucherV2 from '../../components/Vouchers/Participants/PreviewVoucherV2';
var SignupTeam = React.lazy(function () { return import('../../components/SelfServe/SignupTeam/SignupTeam'); });
export var selfServeRoutes = {
    PRODUCT_OPTIONS_PATH: PORTAL_ROUTE_PREFIX + "/product-options",
    SIGN_UP_TEAM_ROUTE: PORTAL_ROUTE_PREFIX + "/sign-up-team", // OK this is a bit weird but it will redirect to login
};
export var PUBLIC_ROUTES = [
    selfServeRoutes.PRODUCT_OPTIONS_PATH,
    selfServeRoutes.SIGN_UP_TEAM_ROUTE,
    ROUTES.OPT_IN,
    ROUTES.CONTACT_SALES,
    ROUTES.CALENDAR,
];
export var PUBLIC_ROUTES_COMPONENTS = [
    React.createElement(Route, { path: selfServeRoutes.PRODUCT_OPTIONS_PATH, exact: true, render: function () {
            var updatedSearchParams = appendParamToSearchParam(LocationPathHelper.getWindowLocationSearch(), QUERY_PARAMS.REFERRER, 'marketing-signup');
            var pathname = "" + selfServeRoutes.SIGN_UP_TEAM_ROUTE + updatedSearchParams;
            return React.createElement(Redirect, { to: pathname });
        } }),
    React.createElement(Route, { path: selfServeRoutes.SIGN_UP_TEAM_ROUTE, exact: true, component: SignupTeam }),
    React.createElement(Route, { path: ROUTES.OPT_IN, exact: true, component: OptIn }),
    React.createElement(Route, { path: ROUTES.CONTACT_SALES, exact: true, component: ContactSales }),
    React.createElement(Route, { path: ROUTES.CALENDAR, exact: true, component: SharedCalendar }),
];
/**
 * In a perfect world, we will just map over the PUBLIC_ROUTES together with some kind of config to get a list of <Route /> components
 *
 * PUBLIC_ROUTES = [{route: PRODUCT_OPTIONS_PATH, exact: true, component: () => <h1>yolo</h1>}].map((props) => <Route {...props} />)
 *
 * BUT React Router and its typescript definitions are messing thing up a bit, it does not compile
 * So falling back to this list of component and do some basic check
 */
export var getPublicRouteComponent = function (isDdfwVouchersKillSwitchOn, isEmWithPersonalAccountEnabled, isVouchersV2PublicPageEnabled) {
    var publicRoutes = __spreadArray([], __read(PUBLIC_ROUTES));
    var publicRouteComponents = __spreadArray([], __read(PUBLIC_ROUTES_COMPONENTS));
    var previewVoucherPage = isVouchersV2PublicPageEnabled
        ? PreviewVoucherV2
        : PreviewVoucher;
    if (!isDdfwVouchersKillSwitchOn) {
        publicRoutes.push.apply(publicRoutes, [ROUTES.PREVIEW_VOUCHER, ROUTES.ACCEPT_VOUCHER]);
        publicRouteComponents.push.apply(publicRouteComponents, [
            React.createElement(Route, { path: ROUTES.PREVIEW_VOUCHER, exact: true, component: previewVoucherPage }),
            React.createElement(Route, { path: ROUTES.ACCEPT_VOUCHER, exact: true, component: AcceptVoucher }),
        ]);
    }
    /* join by invite page is a public page. user log-in flow starts after hitting the page */
    if (isEmWithPersonalAccountEnabled) {
        publicRoutes.push.apply(publicRoutes, [ROUTES.JOIN_BY_INVITE]);
        publicRouteComponents.push.apply(publicRouteComponents, [
            React.createElement(Route, { path: ROUTES.JOIN_BY_INVITE, exact: true, render: function () { return React.createElement(JoinByInviteRoutes, null); } }),
        ]);
    }
    var setOfPublicRoutes = new Set(__spreadArray([], __read(publicRoutes)));
    var allRouteComponentsPaths = [];
    React.Children.forEach(publicRouteComponents, function (element) {
        allRouteComponentsPaths.push(element.props.path || '');
    });
    var setOfPublicRoutesComponentsRoutes = new Set(__spreadArray([], __read(allRouteComponentsPaths)));
    if (publicRouteComponents.length !== publicRoutes.length ||
        setOfPublicRoutes.size !== publicRouteComponents.length ||
        setOfPublicRoutes.size !== setOfPublicRoutesComponentsRoutes.size ||
        !Array.from(setOfPublicRoutes).every(function (publicRoute) {
            return setOfPublicRoutesComponentsRoutes.has(publicRoute);
        })) {
        throw new Error('Not all public routes are mapped to Route components');
    }
    return publicRouteComponents;
};
